<template>
  <div class="container">
    <div class="card">
      <div id="logo">
        <img src="../../assets/KeepNeye.png" width="100" height="100" alt="">
      </div>
      <transition name="fade" mode="out-in">

        <div v-if="!forgot" class="card-block" key="authenticate">
          <div class="row">
            <regular-input
              :value="username"
              @input="username = $event; wrgUser = false"
              :error="wrgUser"
              type="text" :placeholder="$t('login.username')" class="col-12 form-group"/>
            <regular-input
              :value="password"
              @input="password = $event; wrgPass = false"
              @enter="authenticate()"
              :error="wrgPass"
              type="password" :placeholder="$t('login.password')" class="col-12 form-group"/>
          </div>
          <hr>
          <p class="form-group">
            <a href="" @click.prevent="forgot = true">
              {{ $t('login.forgot') }}
            </a>
          </p>
          <p v-if="wrgUser || wrgPass" class="red-text">{{$t('login.invalid_login')}}</p>
          <button @click="authenticate()" class="btn btn-kne-orange col-12">
            {{ $t('login.submit') }}
          </button>

          <!-- No Chatname modal -->
          <modal
          :title="$t('login.modal.chatName')"
          v-if="noChatNameModal"
          @close-request="noChatNameModal = false"
          closable
          >
            <regular-input
              :value="chatFirstName"
              @input="chatFirstName = $event"
              type="text" :placeholder="$t('login.modal.firstName')" class="col-12 form-group"/>

            <regular-input
              :value="chatLastName"
              @input="chatLastName = $event"
              type="text" :placeholder="$t('login.modal.lastName')" class="col-12 form-group"/>
            <button @click="confirmChatName(chatFirstName, chatLastName)" class="btn btn-kne-orange col-11">
              {{ $t('login.modal.confirm') }}
            </button>
          </modal>
        </div>

        <div v-if="forgot" class="card-block" key="forgot">
          <div class="row">
            <label class="mx-3" for="enter_email">{{$t('login.forgot_email_label')}}</label>
            <regular-input
              id="enter_email"
              :value="username"
              @input="username = $event; wrgUser = false"
              :error="wrgUser"
              :success="emailSent"
              @keyup.enter.native="reset()"
              type="text" :placeholder="$t('login.username')" class="col-12 form-group"/>
          </div>
          <hr>
          <p class="form-group">
            <a href="" @click.prevent="forgot = false">
              {{ $t('login.authenticate') }}
            </a>
          </p>
          <p v-if="emailSent">{{$t('login.email_sent')}} <b>{{username}}</b></p>
          <button @click="reset()" class="btn btn-kne-orange col-12">
            {{ $t('login.reset') }}
          </button>
        </div>

      </transition>
    </div>
  </div>
</template>

<script>
import regularInput from '../module/basic-components/regularInput.vue'
import Firebase from 'firebase'
import router from '../../router'
import {db, usersRef} from '../../firebase'
import Modal from '../module/interface-components/Modal.vue'

export default {
  name: 'login',
  components: {
    regularInput,
    Modal
  },

  data () {
    return {
      username: '',
      password: '',
      currentUserID: '',
      currentCompany: '',
      chatFirstName: '',
      chatLastName: '',
      wrgUser: false,
      wrgPass: false,
      noChatNameModal: false,
      forgot: false,
      emailSent: false
    }
  },

  methods: {
    // user2 --> userUID
    authenticate () {
      Firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(async (user) => {
        this.$store.commit('setUser', user.user || false)
        let userUID = Firebase.auth().currentUser.uid.toString()
        if (user !== null) {
          let authorize

          // If userUID has snapshot.val() (Exists), authorize and commit setAuthorization
          await db.ref('users/transportersman').child(userUID).once('value').then((snapshot) => {
            snapshot.val() === null ? authorize = false : authorize = true; this.$store.commit('setAuthorization', snapshot.val())
          })

          if (!authorize) {
            console.log('User not authorized')
            this.wrgUser = true
            this.signOut()
            return
          }

          await db.ref('users/transporters').child(this.$store.state.authorization.company).once('value').then((snapshot) => {
            this.currentCompany = snapshot.child('name').val()
            this.currentUserID = userUID

            this.$store.commit('setUserInfo', snapshot.val())
            if (snapshot.val().language === undefined || snapshot.val().language === '') this.$i18n.set('en')
            else this.$i18n.set(snapshot.val().language)
          })
          if (userUID !== 'e58ff614-8449-4c3e-90b8-b42a48c2972b') this.$store.commit('initAllContact')
        }

        // Check if a user logging in has a username for the chat system.
        await usersRef.doc(userUID)
          .get()
          .then(querySnapshot => {
            if (typeof querySnapshot.data() !== 'undefined' && typeof querySnapshot.data().username !== 'undefined') {
              this.$route.query.redirect ? router.push({path: this.$route.query.redirect}) : router.push({path: '/dashboard'})
            } else {
              // doc.data() will be undefined in this case
              this.noChatNameModal = true
              console.log('No such document!')
            }
          })

        // Check if user has unseen messages
        usersRef.doc(userUID)
        .onSnapshot(querySnapshot => {
          if (querySnapshot.exists) {
            if (querySnapshot.data().hasNewMessage === true) {
              this.$store.state.hasNewMessage = true
            } else {
              this.$store.state.hasNewMessage = false
            }
          }
        })
        }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        if (errorCode === 'auth/invalid-email') this.wrgUser = true
        if (errorCode === 'auth/user-not-found') this.wrgUser = true
        if (errorCode === 'auth/wrong-password') this.wrgPass = true
        console.log(errorCode)
        console.log(errorMessage)
        // ...
      })
    },

    // Button: Confirm username
    // Create chat account with username
    confirmChatName (chatFirstName, chatLastName) {
      if (!this.verifyFullname(chatFirstName, chatLastName)) return
      let fullName = this.mergeFullName(chatFirstName, chatLastName)
      console.log(fullName)

      usersRef.doc(this.currentUserID).set({
        _id: this.currentUserID,
        company: this.currentCompany,
        username: fullName
      }).then(() => {
        this.$route.query.redirect ? router.push({path: this.$route.query.redirect}) : router.push({path: '/dashboard'})
        console.log('user updated!')
      })
    },

    /** Verify if strings are empty
     *  @param chatFirstName : User's first name
     *  @param chatLastName : User's last name
     */
    verifyFullname (chatFirstName, chatLastName) {
      if (chatFirstName.length < 1 || chatLastName.length < 1) {
        return false
      }

      return true
    },

    // Merge the first and last name
    mergeFullName (chatFirstName, chatLastName) {
      let chatFullName = chatFirstName + ' ' + chatLastName
      return chatFullName
    },

    reset () {
      Firebase.auth().sendPasswordResetEmail(this.username).then(() => {
        this.emailSent = true
        alert(`${this.$t('login.email_sent')} ${this.username}`)
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        if (errorCode === 'auth/invalid-email') this.wrgUser = true
        console.log(errorCode)
        console.log(errorMessage)
        // ...
      })
    },

    signOut () {
      Firebase.auth().signOut().then(() => {
        this.$store.commit('clearUser')
        this.$store.commit('clearContacts')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  #logo {
    padding-top: 1.25rem;
  }
  img {
    margin-bottom: 2rem;
  }
  .card {
    margin-top: 3rem;
    text-align: center;
  }
  @media (min-width: 574px) {
    .card {
      margin-right: 0rem;
      margin-left: 0rem;
    }
  }
  @media (min-width: 766px) {
    .card {
      margin-top: 10rem;
      margin-right: 8rem;
      margin-left: 8rem;
    }
  }
  @media (min-width: 990px) {
    .card {
      margin-top: 10rem;
      margin-right: 15rem;
      margin-left: 15rem;
    }
  }
  @media (min-width: 1198px) {
    .card {
      margin-top: 10rem;
      margin-right: 15rem;
      margin-left: 15rem;
    }
  }
</style>
